<template>
  <v-dialog
    persistent
    :value="dialog"
    @input="$emit('disagree')"
    max-width="590"
  >
    <v-card>
      <v-toolbar color="cyan" dark flat>
        <v-toolbar-title>
          Cancelar multa
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-textarea
          name="input-7-1"
          filled
          label="Motivo"
          auto-grow
          v-model="motivo"
          :error-messages="motivoErrors"
        ></v-textarea>

        <v-text-field
          label="Senha"
          required
          v-model="password"
          outlined
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
          :error-messages="passwordErrors"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="$emit('disagree')">
          Sair
        </v-btn>

        <v-btn
          color="green darken-1"
          text
          @click.prevent="
            $v.$invalid
              ? $v.$touch()
              : $emit('agree', { motivo, password })
          "
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
export default {
  props: {
    dialog: Boolean,
    vehicleRequestId: Number,
  },
  data: () => ({
    show1: false,
    motivo: '',
    estorno: true,
    password: null,
  }),
  mixins: [validationMixin],
  validations() {
    if (this.estorno) {
      return { password: { required } };
    }
    return {};
  },
  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Campo obrigatório.');
      return errors;
    },
    motivoErrors() {
      const errors = [];
      if (this.motivo !== '') return errors;
      errors.push('Campo obrigatório.');
      return errors;
    },
  },
  methods: {
    cleanPassword() {
      if (!this.estorno) this.password = null;
    },
  },
};
</script>
